import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { delay, finalize, map } from 'rxjs';

export const busyInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingSvc = inject(LoadingService)
  loadingSvc.busy();
  return next(req).pipe(delay(1000), finalize(() => loadingSvc.idle()));
};
